import React from 'react';

const Content = ({ children, extraClasses = '' }) => (
  <div className={`w-100 ${extraClasses}`}>
    <div className="o-content">{children}</div>
  </div>
);

export default Content;



// WEBPACK FOOTER //
// ./src/components/Content.js